export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Keychain - Pink.aac16568.jpg";